export default __webpack_public_path__ + "static/media/harddrive.4d8c677b.svg";